import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import PermissionAccess from '../../PermissionAccess/Access.js';

const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.small ? 5 : undefined
}))`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid var(--buttons-color, #30b1ff);
  padding: 0 32px 0 16px;
  justify-content: flex-start;
`;

const Select = styled.select`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid var(--buttons-color, #30b1ff);
  margin-left: 10px;
  padding: 0 16px;
`;

const Button = styled.button`
  margin-left: 2%;
  type: button;
  class: btn btn-custom-color btn-hover-shine me-3 btn;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DoctorsListFilter = ({
  onClear,
  onSearch,
  filterText,
  filterStatus,
  filterType,
  filterICVerification,
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [searchText, setSearchText] = useState(filterText || "");
  const [status, setStatus] = useState(filterStatus || "");
  const [type, setType] = useState(filterType || "");
  const [icVerification, setIcVerification] = useState(filterICVerification || "");

  useEffect(() => {
    setSearchText(filterText || "");
    setStatus(filterStatus || "");
    setType(filterType || "");
    setIcVerification(filterICVerification || "");
  }, [filterText, filterStatus, filterType, filterICVerification]);
  
  const handleClear = () => {
    onClear();
    setSearchText('');
    setType('');
    setStatus('');
    setIcVerification('');
  };

  const handleSearch = () => {
    onSearch(searchText, status, type, icVerification);
  };

 
  return (
    <Container>
      <Input
        type="text"
        placeholder={t('Search Text')}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

     <Select
        value={type}
        onChange={(e) => setType(e.target.value)}
      >
        <option value="">{t('Select Type')}</option>
        <option value="Doctor">{t('Doctor')}</option>
        <option value="Nurse">{t('Nurse')}</option>
      </Select>

      <Select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="">{t('Select Status')}</option>
        <option value="Active">{t('Active')}</option>
        <option value="InActive">{t('InActive')}</option>
        <option value="Deleted">{t('Deleted')}</option>
      </Select>

      <Select
        value={icVerification}
        onChange={(e) => setIcVerification(e.target.value)}
      >
        <option value="">{t("IC Verification")}</option>
        <option value="pending">{t("Pending")}</option>
        <option value="approved">{t("Approved")}</option>
        <option value="rejected">{t("Rejected")}</option>
        <option value="re-submission">{t("Re-submission")}</option>
      </Select>

      <Button className="btn btn-custom-color btn-hover-shine me-3 btn"
        onClick={handleSearch}
      >
        {t('Search')}
      </Button>
      <Button className="btn btn-custom-color btn-hover-shine me-3 btn"
        onClick={handleClear}
      >
        {t('Reset')}
      </Button>
    </Container>
  );
};

export default DoctorsListFilter;
